import React, { memo } from 'react';
import { Stack, Typography, Card } from 'investira.react.components';
import { formats } from 'investira.sdk';
import InlineGauge from '../_components/InlineGauge';

const AvaliacoesOutputHighlights = memo(props => {
  const {
    nota = 0,
    notaQuantitativa = 0,
    notaQualitativa = 0,
    proximaAvaliacao,
    justificativas
  } = props;

  const colorNota = (pNota = 0) => {
    return pNota < 1.8
      ? 'error.contrastText'
      : pNota < 2.2
      ? 'warning.contrastText'
      : pNota < 3
      ? 'primary.contrastText'
      : 'primary.contrastText';
  };

  const bgcolorNota = (pNota = 0) => {
    return pNota < 1.8
      ? 'error.main'
      : pNota < 2.2
      ? 'warning.main'
      : pNota < 3
      ? 'primary.main'
      : 'primary.main';
  };

  const formatNota = pNota => {
    //const xNota = Number.isInteger(pNota) ? `${pNota}.0` : pNota;
    return formats.formatNumber(pNota, 2, true, false);
  };

  return (
    <Stack direction="column" sx={{ gap: 1, minWidth: '320px' }} component="section">
      <Stack gap={1} flexGrow={1} direction="column">
        <Card
          sx={{
            display: 'flex',
            flex: 1,
            backgroundColor: bgcolorNota(nota)
          }}>
          <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
            <Typography variant="caption" color={colorNota(nota)} sx={{ fontWeight: 500 }}>
              Nota geral
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack>
                <Typography variant="h2" color={colorNota(nota)} sx={{ fontWeight: 600 }}>
                  {formatNota(nota)}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="caption" color={colorNota(nota)} sx={{ fontWeight: 500 }}>
                  Aprovado / Em conformidade
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>

        <Stack gap={1} direction="row">
          <Stack gap={1} flexGrow={1}>
            <Card
              sx={{
                display: 'flex',
                flex: 1,
                backgroundColor: bgcolorNota(notaQualitativa)
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography
                  variant="caption"
                  color={colorNota(notaQualitativa)}
                  sx={{ fontWeight: 500 }}>
                  Nota qualitativa
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography
                      variant="h6"
                      color={colorNota(notaQualitativa)}
                      sx={{ fontWeight: 600 }}>
                      {formatNota(notaQualitativa)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1}>
            <Card
              sx={{
                display: 'flex',
                flex: 1,
                backgroundColor: bgcolorNota(notaQuantitativa)
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography
                  variant="caption"
                  color={colorNota(notaQuantitativa)}
                  sx={{ fontWeight: 500 }}>
                  Nota quantitativa
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography
                      variant="h6"
                      color={colorNota(notaQuantitativa)}
                      sx={{ fontWeight: 600 }}>
                      {formatNota(notaQuantitativa)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
        <Stack gap={1} direction="row">
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <InlineGauge
                label="Escala da nota geral"
                value={nota}
                min={0}
                max={3}
                ticks={[0, 1, 2, 3]}
                ranges={[
                  { from: 0, to: 1.2, color: 'error.main' },
                  { from: 1.2, to: 2.25, color: 'warning.main' },
                  { from: 2.25, to: 3, color: 'primary.main' }
                ]}
              />
            </Stack>
          </Card>
        </Stack>

        <Stack gap={1} direction="row">
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Próxima avaliação
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {proximaAvaliacao != null ? proximaAvaliacao : 'Fevereiro 2027'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>

      <Stack gap={1} direction="row">
        <Stack gap={1} flexGrow={1}>
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Justificativas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {justificativas != null ? justificativas : '10'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        {/* <Stack gap={1} flexGrow={1}>
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Notas alteradas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    4
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack> */}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesOutputHighlights;
